import React from "react";

const MyCollectionCard = () => {
    return (
        <>
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <div className="_mycol_card_main_wrap">
                    <div className="_mycol_card_main_top">
                        <div className="_mycol_card_main_top_left">
                            <img src="assets/img/mycol1.png" alt="" className="_mycol_card_main_top_left_img" />
                        </div>
                        <div className="_mycol_card_main_top_right">
                            <img src="assets/img/mycol2.png" alt="" className="_mycol_card_main_top_right_img" />
                            <img src="assets/img/mycol3.png" alt="" className="_mycol_card_main_top_right_img" />
                            <img src="assets/img/mycol4.png" alt="" className="_mycol_card_main_top_right_img" />
                        </div>
                    </div>
                    <div className="_mycol_card_main_mid">
                        <div className="_mycol_card_main_mid_left">
                            <h4 className="_mycol_card_main_mid_left_title">3d Wallpapers #56</h4>
                            <p className="_mycol_card_main_mid_left_des">Created by UIHUT</p>
                        </div>
                        <div className="_mycol_card_main_mid_right">
                            <span className="_mycol_card_main_mid_right_item">35 items</span>
                        </div>
                    </div>
                    <div className="_mycol_card_main_btm">
                        <button className="_mycol_card_main_btm_view">View all</button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default MyCollectionCard;